
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface UserListingsEmptyProps {
  statusFilter: string;
  canAddNewListing: boolean;
  onClearFilter: () => void;
}

export const UserListingsEmpty = ({ statusFilter, canAddNewListing, onClearFilter }: UserListingsEmptyProps) => {
  const { t } = useTranslation('common');
  
  return (
    <div className="flex flex-col items-center justify-center rounded-md border border-brand-cloud bg-white p-8 text-center shadow-sm md:p-10">
      <AlertCircle className="mb-4 h-12 w-12 text-brand-slate" />
      <h3 className="mb-2 public-card-title">{t("listings.empty.noListings")}</h3>
      <p className="mb-6 text-brand-slate">
        {statusFilter === "all" 
          ? t("listings.empty.noListingsDescription")
          : t("listings.empty.noFilteredListings", { status: t(`listings.filters.${statusFilter}`) })}
      </p>
      <div className="flex gap-4 flex-wrap justify-center">
        <Button 
          className="bg-brand-ink text-white hover:bg-brand-charcoal"
          disabled={!canAddNewListing}
          asChild={canAddNewListing}
        >
          {canAddNewListing ? (
            <Link to="/submit-listing">{t("listings.empty.addListingButton")}</Link>
          ) : (
            <>{t("listings.empty.addListingButton")}</>
          )}
        </Button>
        
        {statusFilter !== "all" && (
          <Button onClick={onClearFilter} variant="outline">
            {t("listings.empty.viewAllButton")}
          </Button>
        )}
      </div>
    </div>
  );
};
